export class Pricing {
    public id: number = 0;
    public name?: string;
    public projectId: number = 0;
    public selected: boolean = false;
    public disabled: boolean = false;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    public clone(): Pricing {
        const pricing: Pricing = new Pricing();

        pricing.id = this.id;
        pricing.name = this.name;
        pricing.projectId = this.projectId;
        pricing.selected = this.selected;
        pricing.disabled = this.disabled;

        return pricing;
    }
}
